import React from 'react';
import { connect } from 'react-redux';
import { updateData, updateFilterData, updateEditData } from "../actions";
import ControlService from "../../helper/controlservice";
const uuidv4 = require('uuid/v4');

function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        updateFilter: (key, value, key2) => dispatch(updateFilterData(key, value, key2))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    token: state.formLoginReducer.token,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading
});
const ROMAN = ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII'];
class AutocompleteUI extends React.PureComponent {
    static selectedIndex = -1;
    state = {
        apiData: [],
        isApiCalling: true,
        query: '',
        filteredList: [],
        AutoSearchList: [],
        firstLoad: false,
        searchDropDown: false,
        touched: false,
        value: ''
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        var nextData = nextProps.data && nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid] : {};
        return {
            value: nextData[nextProps.control.key]
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.value && this.state.value != prevState.value) {
            ControlService().controlVaildationCheck(this.props);
        }
    }
    componentDidMount() {
        if (this.props.control.refreshbindingonfirstload == true) {
            this.refreshBindingControls();
        } else {
            this.state.firstLoad = true;
        }
        ControlService().controlVaildationCheck(this.props);
    }
    clearBindingControls(control, formid) {
        if (control.bindingwithothercontrols && !this.state.firstLoad) {
            control.bindingwithothercontrols.forEach(ctr => {
                this.props.update(ctr.controlkey, '', formid);
            });
        } else {
            this.setState({ firstLoad: false });
        }
    }
    initializeControl() {
        this.setState({ searchDropDown: !this.state.searchDropDown });
    }
    refreshBindingControls() {
        const { control, formid } = this.props;
        if (control.actiondatasource) {
            var apiurl = "";
            var apiparam = {};
            if (control.bindingwithothercontrols) {
                control.bindingwithothercontrols.forEach(ctr => {
                    this.props.update(ctr.controlkey, '', formid);
                });
            }
            // ...using get request
            apiurl = control.ResultApi ? control.ResultApi : "";
            const data = this.props.data[formid];
            control.ResultApiParam.forEach(option => {
                apiparam[option.key] = option.value;
            })
            if (control.bindingqueryfield) {
                apiparam[control.bindingqueryfield] = data[control.key];
            }
            let _control = ControlService().extractControl(control, 'action');
            ControlService().ServiceRequest(apiurl, apiparam, _control, this.props.token)
                .then((res) => {
                    var dataOtption = {}
                    if (Array.isArray(res) && res.length > 0)
                        dataOtption = res[0] ? res[0] : {};
                    else if (typeof res == "object")
                        dataOtption = res ? res : {};

                    control.bindingwithothercontrols.forEach(_ctrl => {
                        this.props.update(_ctrl.controlkey, dataOtption[_ctrl.bindingfield], formid);
                    });
                })
                .catch(err => {
                    console.log("refreshBindingControls-AutoComplete")
                });
        }

    }
    CallService(term) {
        const { control, formid } = this.props;
        var apiurl = "";
        var apiparam = {};
        this.isLoading = true;
        this.setState({
            searchDropDown: true,
            isApiCalling: true
        })

        // ...using get request
        var data = this.props.data[formid] ? this.props.data[formid] : {}
        if (data[control.key].length >= 2) {
            if (control.apiurl !== "") {
                apiurl = control.apiurl;
                control.optionlist.forEach(option => {
                    apiparam[option.key] = option.value;
                })
                if (control.queryfield !== "")
                    apiparam[control.queryfield] = data[control.key];
                // }
                // else {
                //   apiurl = this.url;
                //   apiparam = this.params;
                // }

                ControlService().ServiceRequest(apiurl, apiparam, this.props.control, this.props.token, data)
                    .then(res => {
                        var result = [];
                        if (control.responsefield) {
                            result = res ? res[control.responsefield] : [];
                        } else {
                            result = res;
                        }
                        this.isLoading = false;
                        var filteredList = this.state.filteredList;
                        var AutoSearchList = this.state.AutoSearchList;
                        var apiData = result;
                        result.forEach(item => {
                            var arr = {};
                            arr[control.textfield] = item[control.textfield];
                            arr[control.valuefield] = item[control.valuefield];
                            if (filteredList.filter(x => x[control.textfield] == arr[control.textfield]).length == 0) {
                                filteredList.push(arr);
                            }
                        })
                        //this.state.AutoSearchList = [];
                        if (term == data[control.key]) {
                            filteredList.forEach(item => {
                                if (item[control.textfield].match(new RegExp(term, 'gi')) && AutoSearchList.filter(x => x[control.textfield] == item[control.textfield]).length == 0) {
                                    AutoSearchList.push(item);
                                }
                            })
                        }

                        this.setState({
                            AutoSearchList: AutoSearchList,
                            filteredList: filteredList,
                            apiData: apiData,
                            isLoading: false
                        });
                    })
                    .catch(err => {
                        console.log("CallService-AutoComplete")
                    });
            } else {
                this.setState({
                    AutoSearchList: [],
                    isLoading: false
                });
            }
        }
    }
    eventHandler(event) {
        const { control } = this.props;
        this.setState({
            searchDropDown: true
        })
        if (event.keyCode == 40) {
            event.stopPropagation();

            if (this.selectedIndex >= -1 && (this.selectedIndex < this.state.AutoSearchList.length)) {
                this.selectedIndex = this.selectedIndex + 1;
            }
            else {
                this.selectedIndex = 0;
            }
            if (this.selectedIndex > 0 && event.currentTarget.nextElementSibling && event.currentTarget.nextElementSibling.children.length > 0 && event.currentTarget.nextElementSibling.children[0].children[this.selectedIndex]) {
                event.currentTarget.nextElementSibling.scrollTop += event.currentTarget.nextElementSibling.children[0].children[this.selectedIndex].scrollHeight;
            } else if (event.currentTarget.nextElementSibling) {
                event.currentTarget.nextElementSibling.scrollTop = 0;
            }
            //console.log("ArrowDown " + this.selectedIndex)
        }
        if (event.key == "ArrowUp") {
            event.stopPropagation();

            if (this.selectedIndex > -1 && (this.selectedIndex != 0)) {
                this.selectedIndex = this.selectedIndex - 1;
            }
            else {
                this.selectedIndex = this.state.AutoSearchList.length - 1;
                // this.setState({ selectedIndex: this.state.AutoSearchList.length - 1 });
            }
            if (event.currentTarget.nextElementSibling && event.currentTarget.nextElementSibling.children.length > 0 && event.currentTarget.nextElementSibling.children[0].children[this.selectedIndex]) {
                //event.currentTarget.nextElementSibling.scrollTop = this.selectedIndex * 26;
                event.currentTarget.nextElementSibling.scrollTop -= event.currentTarget.nextElementSibling.children[0].children[this.selectedIndex].scrollHeight;
            }
            //console.log("ArrowUp " + this.selectedIndex)
        }

        if (event.key == "Enter") {
            if (this.selectedIndex > -1) {
                //console.log("Enter " + this.selectedIndex)
                event.stopPropagation();
                this.select(this.state.AutoSearchList[this.selectedIndex], control, this.props.action);

                if (control.refreshcomponenton && control.refreshcomponenformid) {
                    this.props.update(control.refreshcomponenton + '_refresh', uuidv4(), control.refreshcomponenformid + 'write')
                }
            } else if (control.refreshcomponenton && control.refreshcomponenformid) {
                this.props.update(control.refreshcomponenton + '_refresh', uuidv4(), control.refreshcomponenformid + 'write')
            }
        }
    }
    select(selectedValues, control, action) {

        this.setState({ searchDropDown: false, AutoSearchList: [] })
        if (action == 'write')
            this.props.update(control.key, selectedValues[control.valuefield], this.props.formid);
        else if (action == 'filter')
            this.props.updateFilter(control.key, selectedValues[control.valuefield]);
        else if (action == 'edit')
            this.props.updateEdit(control.key, selectedValues[control.valuefield]);


        if (this.state.apiData.length > 0 && this.props.control.storejsonnode == true) {
            this.props.update(control.key + "_node", this.state.apiData.find(x => x[this.props.control.valuefield] == selectedValues[control.valuefield]), this.props.formid);
        }
    }
    filter(control, data) {
        var val = data[control.key];
        if (val && this.state.searchDropDown) {
            this.CallService(val);

            if (this.state.filteredList.length > 0) {
                //this.AutoSearchList = val ? this.filteredList.filter((s) => s[control.textfield].match(new RegExp(val, 'gi'))) : this.filteredList;
                var AutoSearchList = [];
                this.state.filteredList.forEach(item => {
                    if (item[this.props.control.textfield].match(new RegExp(val, 'gi')) || item[this.props.control.valuefield].startsWith(val)) {
                        AutoSearchList.push(item);
                    }
                })
                this.setState({ AutoSearchList: AutoSearchList });
            }
        }
        else {
            this.setState({ AutoSearchList: [] });
        }
    }
    keypress(control, data, event) {

        if (!this.state.searchDropDown) {
            this.setState({ searchDropDown: true, selectedIndex: -1 });
        }
        if (control.textonly && control.numberonly && (/^[a-zA-Z\s]*$/.test(event) || /^[0-9]*$/.test(event.key))) {
            if (control.charlimit) {
                return data[control.key].length < control.charlimit;
            } else {
                return true;
            }
        } else if (control.textonly && !/^[a-zA-Z\s]*$/.test(event)) {
            return false;
        } else if (control.numberonly && !/^[0-9]*$/.test(event)) {
            return false;
        } else if (control.charlimit) {
            return data[control.key].length < control.charlimit;
        } else {
            return true;
        }
    }
    onValueChange(value, control, action, formid) {
        this.selectedIndex = -1;
        const _data = this.props.data[formid] ? this.props.data[formid] : {}
        if (this.keypress(control, _data, value)) {
            if (action == 'filter') {
                this.props.updateFilter(control.key, value)
            }
            else if (action == 'write') {
                this.props.update(control.key, value, formid)
            }
            else if (action == 'edit') {
                this.props.updateEdit(control.key, value)
            }

            this.clearBindingControls(control, formid)
            this.filter(control, _data)
        }
        if (!value && control.refreshcomponenton && control.refreshcomponenformid) {
            this.props.update(control.refreshcomponenton + '_refresh', uuidv4(), control.refreshcomponenformid + 'write')
        }
    }
    resetControl() {
        this.setState({ AutoSearchList: [], filterdata: [], searchDropDown: false, selectedIndex: -1 });
    }
    handleBlur = () => {
        this.refreshBindingControls(this.props);
        this.setState({
            touched: true,
        });
    }
    shouldMarkError(control, data) {
        const validate = ControlService().validate(control, data[control.key]);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;

        return validate ? !validate : shouldShow;
    }
    render() {
        const { control, action, formid } = this.props;
        const data = this.props.data[formid] ? this.props.data[formid] : {};
        const shouldMarkError = this.shouldMarkError(control, data);

        return (
            <div className={control.key == 'searchfilterbox' ? "" : "form-group"}>
                {control.label &&
                    <label htmlFor={control.id}>{control.label}
                        {control.require &&
                            <sup className="text-danger font-weight-bold">*</sup>
                        }
                        {control.showhelptext &&
                            <span className={"custom-tooltip"}>
                                <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                            </span>
                        }
                    </label>
                }
                {control.imageurl &&
                    <img src="control.imageurl" alt={control.label} width="100" height="100" className="mb-2 img-fluid" />
                }
                <div className="dropdown-outer">
                    <input onKeyDown={(event) => this.eventHandler(event)}
                        aria-label={control.label}
                        autoComplete="off"
                        id={control.key}
                        type="text"
                        className={'form-control ' + (shouldMarkError ? "border-danger" : "")}
                        onBlur={() => { this.handleBlur(); this.resetControl() }}
                        style={{ 'minWidth': '115px' }}
                        onChange={(e) => this.onValueChange(e.target.value, control, action, formid)}
                        onClick={() => this.initializeControl()}
                        value={data[control.key]}
                        placeholder={control.placeholder}
                        disabled={this.props.disabled}
                    />
                    {this.state.filteredList.length > 0 && this.state.AutoSearchList.length > 0 &&
                        <div className="dropdown-option">
                            <ul className="list-group">
                                {this.state.AutoSearchList.map((item, idx) => {
                                    return (
                                        <li name={idx} onKeyDown={(event) => this.eventHandler(event)} onMouseOver={() => this.selectedIndex = idx}
                                            onMouseDownCapture={() => this.select(item, control, action)} className={"list-group-item list-group-item-action" + (idx == this.selectedIndex ? " active" : '')}
                                        >
                                            <span>
                                                {item[control.textfield]}
                                            </span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    }
                    {(shouldMarkError && !control.charlimit) &&
                        <small className="form-text text-danger">
                            {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                        </small>
                    }
                    {(shouldMarkError && control.charlimit) &&
                        <small className="form-text text-danger">
                            You can enter maximum {control.charlimit} characters.
                            </small>
                    }
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps, bindAction
)(AutocompleteUI);